import { render, staticRenderFns } from "./PurchasesOrderStatusBadge.vue?vue&type=template&id=4f7e9a7f"
import script from "./PurchasesOrderStatusBadge.vue?vue&type=script&lang=js"
export * from "./PurchasesOrderStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports